
const IntroContentAr = () => {
    return <>
      <section className="home_banner pt-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="col_selector text-right">
                <h2 className="mb-3">
                  شبكة التواصل الاجتماعي <br/> الخاصة بحييك 
                </h2>
              </div>
            </div>
          </div>
        </div>
        <img
          src="assets/images/index-banner.png"
          className="img-fluid w-100"
          alt="banner"
          style = {{transform: 'scaleX(-1)'}}
        />
      </section>

      <section className="known_banner">
        <div className="container">
          <div className="row">
            <div
              className="col-md-5 d-flex align-items-center text-right"
              style={{ minHeight: 660 }}
            >
              <div className="col_selector">
                <div className="known_thingsRTL position-relative">
                  <img
                    src="assets/images/tick.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 "
                      style={{ color: "#F55767" }}
                    >
                      مفيد
                    </h4>
                    <p className="mb-0 fz14 ">
                         أسهل طريقة لمواكبة كل شيء <br/>في منطقتك.
                    </p>
                  </div>
                </div>
                <div className="known_thingsRTL position-relative">
                  <img
                    src="assets/images/lock.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 "
                      style={{ color: "#2563FF" }}
                    >
                      خاصة
                    </h4>
                    <p className="mb-0 fz14 ">
                        بيئة خاصة مصممة خصيصًا لك  <br/>ولجيرانك.
                    </p>
                  </div>
                </div>
                <div className="known_thingsRTL position-relative">
                  <img
                    src="assets/images/proven.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 "
                      style={{ color: "#40975F" }}
                    >
                      مبرهنة
                    </h4>
                    <p className="mb-0 fz14 ">
                        أكثر من 127000 حي يعتمد على <br/> حومتي.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7"></div>
          </div>
        </div>
      </section>

      <section className="neighbours_section text-right">
        <div className="container">
          <h2 className="text-center  base_color">
              عندما يبدأ الجيران الحديث، الأشياء الجيدة تحدث.
          </h2>
          <div className="row">
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/stronger.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2  fz18"
                  style={{ color: "#F55767" }}
                >
                  ابني حيا أقوى
                </h4>
                <p className="mb-0 fz14 ">
                 تواصل مع جيرانك للبقاء على اطلاع على اخبار الحي 
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/neighbour.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2  fz18"
                  style={{ color: "#2563FF" }}
                >
                  حافظ على سلامة الحي
                </h4>
                <p className="mb-0 fz14 ">
                    ارعوا بعضكم البعض وأرسل التحديثات للحفاظ على أمن الحي.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/sharegood.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2  fz18"
                  style={{ color: "#40975F" }}
                >
                  تبادل السلع والتوصيات
                </h4>
                <p className="mb-0 fz14 ">
                    اعثر على العاب أطفال رائعة أو طبيب أسنان موثوق. استعير سلمًا أو قم ببيع خزانة الكتب القديمة
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
}

export default IntroContentAr;